import { createFeatureSelector, createSelector } from '@ngrx/store';
import {
  SUGGESTIONS_FEATURE_KEY,
  State,
  suggestionsAdapter,
} from './suggestions.reducer';

// Lookup the 'Suggestions' feature state managed by NgRx
export const getSuggestionsState = createFeatureSelector<State>(
  SUGGESTIONS_FEATURE_KEY,
);

const { selectAll, selectEntities } = suggestionsAdapter.getSelectors();

export const getSuggestionsLoaded = createSelector(
  getSuggestionsState,
  (state: State) => state.loaded,
);

export const getSuggestionsError = createSelector(
  getSuggestionsState,
  (state: State) => state.error,
);

export const getAllSuggestions = createSelector(
  getSuggestionsState,
  (state: State) => selectAll(state),
);

export const getSuggestionsEntities = createSelector(
  getSuggestionsState,
  (state: State) => selectEntities(state),
);

export const getSelectedId = createSelector(
  getSuggestionsState,
  (state: State) => state.selectedId,
);

export const getSelected = createSelector(
  getSuggestionsEntities,
  getSelectedId,
  (entities, selectedId) => (selectedId ? entities[selectedId] : undefined),
);
